import React from 'react';

import { TravelSymbolProps } from './TravelSymbol.interface';
import { useStyles } from './TravelSymbol.styles';

export default function TravelSymbol(props: TravelSymbolProps) {
  const classes = useStyles();

  return (
    <div className={classes.travelSymbolContainer}>
      <img
        src="./images/travel/travel.svg"
        alt=""
        className={classes.travelSymbol}
        loading="lazy"
      />
    </div>
  );
}
